import { Chip, Badge } from '@atoms/index';
import { useRef, useState } from 'react';

const MultiInput = ({
  name = 'value', values, onDelete, onChange, placeholder, validationRegex, error, ...rest
}) => {
  const [isInputFocused, setInputFocused] = useState(false);
  const [duplicateMessage, setDuplicateMessage] = useState('');

  const inputRef = useRef(null);

  const addDomainIfValid = (value) => {
    if (values.includes(value)) {
      setDuplicateMessage(`The provided ${name} has already been added.`);
      inputRef.current.focus();
      inputRef.current.select();
    } else if (validationRegex.test(value)) {
      onChange([...values, value]);
      inputRef.current.value = '';
      setDuplicateMessage('');
    }
  };

  const _handleKeyDown = (e) => {
    const value = e.target.value.trim()?.toLowerCase();
    if (['Enter', ' ', 'Tab', ','].includes(e.key)) {
      e.preventDefault();
      addDomainIfValid(value);
    }
  };

  const _handlePaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData('Text');
    const emailList = pastedText.split(/[\s,;\t\r\n]+/);
    const newValues = [];

    emailList.forEach((email) => {
      const trimmedEmail = email.trim()?.toLowerCase();
      if (validationRegex.test(trimmedEmail)) {
        if (!values.includes(trimmedEmail) && !newValues.includes(trimmedEmail)) {
          newValues.push(trimmedEmail);
        } else {
          setDuplicateMessage(`The provided ${name} has already been added.`);
        }
      } else {
        setDuplicateMessage(`Please provide a valid ${name}.`);
      }
    });

    if (newValues.length > 0) {
      onChange([...values, ...newValues]);
      setDuplicateMessage('');
    }
  };

  const handleInputFocus = () => {
    setInputFocused(true);
    setDuplicateMessage('');
  };

  const handleInputBlur = (e) => {
    const value = e.target.value.trim()?.toLowerCase();
    addDomainIfValid(value);
    setInputFocused(false);
  };

  return (
    <div className='w-full'>
      <div
        onClick={() => inputRef.current.focus()}
        className={`relative border w-full flex flex-wrap items-center rounded-md gap-1.5 ${(duplicateMessage || error) ? 'border-pure-red-500 dark:border-pure-red-500' : 'hover:border-neutral-40 border-neutral-30'} ${isInputFocused ? 'border-yellow-500 dark:border-yellow-500' : ''} pl-2 pr-22 py-1 bg-white dark:bg-transparent`}
      >
        {values?.map((value, index) => (
          <Chip onDelete={() => { onDelete(index); setDuplicateMessage(''); }} value={value} key={index} />
        ))}
        <input
          {...rest}
          ref={inputRef}
          autoFocus
          placeholder={values.length > 0 ? '' : placeholder}
          onPaste={_handlePaste}
          className="flex-1 min-w-[50px] text-sm outline-none dark:bg-transparent"
          onKeyDown={_handleKeyDown}
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
        />
        <div className='flex gap-1.5 items-center absolute right-2'><span className='text-xs text-grey-700'>Hit</span> <Badge variant="soon" className='!text-grey-700 dark:!text-grey-200 font-normal'>Return</Badge></div>
      </div>
      {error && <p className="text-pure-red-500 text-xs ml-2 mt-2">{error}.</p>}
      {duplicateMessage && <p className="text-pure-red-500 dark:text-pure-red-500 text-xs ml-2 mt-2">{duplicateMessage}</p>}
    </div>
  );
};

export default MultiInput;
